import React from 'react';
import classnames from 'classnames';

type PillTabValue = string | number;

interface PillTabItem {
  value: PillTabValue;
  label?: React.ReactNode;
  isDefaultActive?: boolean;
}

interface Props {
  tabs: PillTabItem[];
  className?: string;
  isActive: (value: PillTabValue) => boolean;
  onTabClick: (value: PillTabValue) => void;
}

const PillTab: React.FC<Props> = (props) => {
  const { tabs, className, isActive, onTabClick } = props;

  const [, defaultTabIndex] = tabs.reduce<[number | undefined, number | undefined]>(
    (acc, tab, tabIndex) => {
      if (isActive(tab.value)) {
        acc[0] = tabIndex;
      }

      if (tab.isDefaultActive) {
        acc[1] = tabIndex;
      }

      return acc;
    },
    [undefined, undefined]
  );

  let activeTabIndex = tabs.findIndex((tab) => isActive(tab.value));
  if (activeTabIndex < 0) {
    activeTabIndex = defaultTabIndex ?? 0;
  }

  return (
    <div className="pill-tabs">
      {tabs.map((tab, index) => {
        return (
          <button
            key={String(tab.value)}
            className={classnames('pill-tabs__btn', {
              [className]: className,
              'pill-tabs__btn--active': index === activeTabIndex,
            })}
            onClick={() => onTabClick(tab.value)}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default PillTab;
